import React, { FC, useEffect } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { rules } from 'common/helpers';
import { URL_PATTERN } from 'common/config';
import { IFormValue } from 'common/models';
import { Close } from 'common/svg';
import { IUpdateAccountPayload } from 'entities/Account/Account.models';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  url?: string;
  onClose: () => void;
  onSave: (payload: Omit<IUpdateAccountPayload, 'id'>) => void;
}

export const WebhookUrlChangeModal: FC<IComponentProps> = ({ open, loading, url, onClose, onSave }) => {
  const [form] = useForm();

  const handleClose = () => {
    onClose();
    form.resetFields();
  };

  const onSubmit = ({ webhookUrl }: IFormValue) => {
    onSave({ webhookUrl, onSuccess: handleClose });
  };

  useEffect(() => {
    if (open && url) {
      form.setFieldsValue({ webhookUrl: url });
    }
  }, [open, url]);

  return (
    <Modal
      rootClassName="redesign modal"
      width={400}
      title="Настройка webhookUrl"
      centered
      open={open}
      onCancel={handleClose}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleClose} disabled={loading}>
          Отмена
        </Button>,
        <Button key="save" className="button-sm primary" loading={loading} onClick={form.submit}>
          Сохранить
        </Button>,
      ]}
    >
      <Form form={form} requiredMark={false} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          label="webhookUrl"
          name="webhookUrl"
          rules={[
            rules.required(),
            rules.pattern(URL_PATTERN, 'Некорректная ссылка. Пожалуйста, проверьте формат ссылки и попробуйте ещё раз.'),
          ]}
        >
          <Input
            placeholder="Добавьте URL для интеграции с 1С"
            allowClear={{ clearIcon: <Close className="icon-close-input" /> }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
